const SearchStatic = ({ staticData, handleSuggestionClick, noresults }) => {
	const sections = staticData.static.sections;

	return (
		<div className={`search-static-outer ${noresults ? 'py-4' : 'p-6'}`}>
			<div className='search-static-inner flex flex-col md:flex-row gap-2 md:gap-8 w-full'>
				{sections.map((s, index) => {
					if (s.title === 'Top Categories') {
						return (
							<div
								className={`search-static-section w-full static-section-${
									s.slug
								} ${noresults ? 'w-full' : 'md:flex-1'}`}
								key={index}
							>
								<div className='search-static-title text-base md:text-lg mb-2'>
									{s.title}
								</div>
								<div className='search-static-content mt-1 mb-4'>
									<ul className='categories-list nostyle grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-8'>
										{s.categories.map((c, i) => {
											return (
												<li
													className='category-item'
													key={i}
												>
													<div className='category-item-image hover:opacity-80'>
														<a href={c.url}>
															<div
																className="aspect-[2/3] flex items-center justify-center"
																style={{ backgroundColor: c.vendor === 'Monica + Andy' ? '#f8f8f8' : '#ffffff' }}
															>
																<img
																	src={c.imageSrc}
																	alt={c.imageAlt}
																	loading='lazy'
																	className="w-full h-full object-contain"
																/>
															</div>
														</a>
													</div>
													<div className='category-item-title mt-2'>
														<a
															className=''
															href={c.url}
														>
															{c.title}
														</a>
													</div>
												</li>
											);
										})}
									</ul>
								</div>
							</div>
						);
					}
					return null;
				})}
				<div
					className={`search-static-stack w-full md:w-64 lg:w-80 ${
						noresults ? 'hidden' : ''
					}`}
				>
					{sections.map((s, index) => {
						if (s.title === 'Top Searches') {
							return (
								<div
									className={`search-static-section static-section-${s.slug}`}
									key={index}
								>
									<div className='search-static-title text-base md:text-lg mb-2'>
										{s.title}
									</div>
									<div className='search-static-content mt-1 mb-4'>
										<ul className='searches-list nostyle flex flex-wrap gap-2 px-2 md:flex md:flex-col md:flex-nowrap'>
											{s.searches.map((search, i) => {
												return (
													<li
														className='search-item text-sm w-[100px] lg:w-[120px] font-normal text-flint hover:text-ash hover:underline cursor-pointer'
														key={i}
														onClick={() =>
															handleSuggestionClick(
																search.title
															)
														}
													>
														{search.title}
													</li>
												);
											})}
										</ul>
									</div>
								</div>
							);
						}
						if (s.title === 'Top Classes + Events') {
							return (
								<div
									className={`search-static-section static-section-${s.slug} hidden md:block`}
									key={index}
								>
									<div className='search-static-title text-base md:text-lg mb-2 flex items-center'>
										{s.title}{' '}
										<a
											href='/pages/all-classes-events'
											className='view-all text-xs md:text-base ml-auto font-normal text-flint hover:text-ash hover:underline hover:cursor-pointer'
										>
											View All »
										</a>
									</div>
									<div className='search-static-content mt-1 mb-4'>
										<ul className='classes-list nostyle'>
											{s.classes.map((c, i) => {
												return (
													<li
														className='class-item text-sm font-normal my-2'
														key={i}
													>
														<a
															className='text-flint hover:text-ash hover:underline hover:cursor-pointer'
															href={c.url}
														>
															{c.title}
														</a>
													</li>
												);
											})}
										</ul>
									</div>
								</div>
							);
						}
						return null;
					})}
				</div>
			</div>
		</div>
	);
};

export default SearchStatic;
